import {Publication} from '../types/Publication';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class PublicationsService {
  public async getAllPublications(): Promise<Publication[]> {
    return handleError(
      () => httpClient.get<Publication[]>('/publications'),
      'Error fetching publications:',
      () => []
    );
  }

  public async getPublication(id: string): Promise<Publication> {
    return handleError(
      () => httpClient.get<Publication>(`/publications/${id}`),
      'Error fetching publication:'
    );
  }

  public async createPublication(publication: Omit<Publication, 'id'>): Promise<void> {
    const publicationWithId = {
      ...publication,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/publications', publicationWithId),
      'Error creating publication:'
    );
  }

  public async updatePublication(publication: Publication): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/publications/${publication.id}`, publication),
      'Error updating publication:'
    );
  }

  public async deletePublication(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/publications/${id}`),
      'Error deleting publication:'
    );
  }
}

const publicationsService = new PublicationsService();
export default publicationsService;

